import { render, staticRenderFns } from "./PharmacyGroups.vue?vue&type=template&id=4c406479&"
import script from "./PharmacyGroups.vue?vue&type=script&lang=js&"
export * from "./PharmacyGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports